//   ####    ###     ####  ##   ##  ##      #####   ####   ####
//  ##      ## ##   ##     ##   ##  ##      ##     ##     ##
//  ##     ##   ##   ###   #######  ##      #####   ###    ###
//  ##     #######     ##  ##   ##  ##      ##        ##     ##
//   ####  ##   ##  ####   ##   ##  ######  #####  ####   ####
/*
キャッシュレス決済の有無の切り替えでクレカと電子マネーのチェックを切り替え
クレカと電子マネーに変更があった場合も大本を切り替え
*/
//            #####     ###    #####    #####  ##     ##  ######
//            ##  ##   ## ##   ##  ##   ##     ####   ##    ##
//  ########  #####   ##   ##  #####    #####  ##  ## ##    ##
//            ##      #######  ##  ##   ##     ##    ###    ##
//            ##      ##   ##  ##   ##  #####  ##     ##    ##
// 親が切り替えられた
window.addEventListener('change', function (e) {
  const item = e.target.closest('.js-cashless-parent')
  if (!item) {
    return
  }
  const isCashless = item.classList.contains('js-cashless-true')
  cashlessParentOrder(isCashless)
})

// 子を親に合わせる
function cashlessParentOrder(isCashless) {
  let checkList
  if (isCashless) {
    // 子の「利用不可」をチェック解除
    checkList = document.querySelectorAll('.js-cashless-false')
  } else {
    // 子の「利用不可」以外をチェック解除
    checkList = document.querySelectorAll('.js-cashless-true')
  }
  for (const check of checkList) {
    check.checked = false
  }

  if (!isCashless) {
    // 「利用不可」をチェック
    checkList = document.querySelectorAll('.js-cashless-false')
    for (const check of checkList) {
      check.checked = true
    }
  }
}
//             ####  ##   ##  ##  ##      ####
//            ##     ##   ##  ##  ##      ##  ##
//  ########  ##     #######  ##  ##      ##  ##
//            ##     ##   ##  ##  ##      ##  ##
//             ####  ##   ##  ##  ######  ####
// 子が切り替えられた
window.addEventListener('change', function (e) {
  const item = e.target.closest('.js-cashless-child')
  if (!item) {
    return
  }
  if (item.checked) {
    // チェックが入れられた場合のみ処理
    const isCashless = item.classList.contains('js-cashless-true')
    const checkName = item.name
    cashlessChildOrder(isCashless, checkName)
  }
})

// 親を子に合わせる
function cashlessChildOrder(isCashless, checkName) {
  if (isCashless) {
    // 同じ子の「利用不可」を外す
    document.querySelector('.js-cashless-false[name="' + checkName + '"]').checked = false

    // 親を「利用可」に変更
    document.querySelector('.js-cashless-parent.js-cashless-true').checked = true
  } else {
    // 同じnameの子の「利用不可」以外を外す
    const checkList = document.querySelectorAll('.js-cashless-true[name="' + checkName + '"]')
    for (const check of checkList) {
      check.checked = false
    }

    // 他のnameの子も利用不可か確認
    const childList = document.querySelectorAll('.js-cashless-child.js-cashless-false')
    let isAllFalse = true // 全てが利用不可かどうかの判定
    for (const check of childList) {
      if (!check.checked) {
        isAllFalse = false
        break
      }
    }
    if (isAllFalse) {
      // 全てのnameの子が「利用不可」なら親も「利用不可」に変更
      document.querySelector('.js-cashless-parent.js-cashless-false').checked = true
    }
  }
}
